import { useEffect, useState } from 'react';
import { getEstadoCopiaGarra } from '../api/garra';
import { avisoCopiaGarra } from '../domain/garraCopia';
import type { AvisoCopiaGarra } from '../domain/garraCopia';

/**
 * Aviso de la copia de GARRA, solo cuando la campaña elegida es la de GARRA.
 *
 * Carga sus propios datos y, si la consulta falla o quien mira no tiene permiso, no se dibuja:
 * es un aviso complementario y no debe romper Validación (mismo criterio que AlertasDeDocumentos).
 */
export default function EstadoCopiaGarra({ campaignId }: { campaignId: string }) {
  const [aviso, setAviso] = useState<AvisoCopiaGarra | null>(null);

  useEffect(() => {
    let vivo = true;
    setAviso(null);
    if (!campaignId) return;
    void (async () => {
      try {
        const e = await getEstadoCopiaGarra();
        if (vivo && e && e.campaignId === campaignId) setAviso(avisoCopiaGarra(e));
      } catch {
        // Silencio deliberado: ver el comentario del componente.
      }
    })();
    return () => { vivo = false; };
  }, [campaignId]);

  if (!aviso) return null;
  return aviso.tono === 'alerta' ? (
    <p className="mb-4 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      {aviso.texto}
    </p>
  ) : (
    <p className="mb-4 text-sm text-slate-600">{aviso.texto}</p>
  );
}
